import axios from 'axios';

export const axiosInstance = axios.create({
    headers: {
        'Cache-control': 'no-store',
        'Pragma': 'no-cache',
        'Expires': 0
    },
    timeout: 15000
});

export const loadResources = (setCirrusInfoLoaded, setCirrusInfoObject) => {
    if(process.env.NODE_ENV === 'development') {
        // set info object if needed
        setCirrusInfoLoaded(true);
    }
    else {
        axios.get(process.env.PUBLIC_URL + '/cirrus.info').then(
            response => {
                const infoObject = {};
                response.data.split('\n').forEach(row => {
                    const temp = row.split('=');
                    infoObject[temp[0]] = temp[1];
                });
    
                setCirrusInfoObject(infoObject);
    
                if(process.env.NODE_ENV === 'production') {
                    const portalUrl = infoObject['cirrus.api.url'];
                    axiosInstance.defaults.baseURL = portalUrl;
                    setCirrusInfoLoaded(true);
                } else {
                    setCirrusInfoLoaded(true);
                }
            }
        );
    }
}